import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_2 = { class: "text-muted" }
const _hoisted_3 = { class: "font-monospace" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "form-check" }
const _hoisted_6 = {
  class: "form-check-label",
  for: "banPermanent"
}
const _hoisted_7 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_8 = {
  class: "form-label",
  for: "banDuration"
}
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 2,
  class: "alert alert-danger",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.ban_user'),
    modelValue: _ctx.isVisible,
    "footer-class": "d-flex justify-content-end",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isVisible = $event))
  }, {
    default: _withCtx(() => [
      (_ctx.userId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.helper.trans('labels.user_id')) + ": ", 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.userId), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "form-check-input",
            id: "banPermanent",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.permanent) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.permanent]
          ]),
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.permanent_ban')), 1)
        ])
      ]),
      (!_ctx.permanent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.duration_seconds')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              id: "banDuration",
              class: "form-control",
              min: "1",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.durationSeconds) = $event)),
              placeholder: _ctx.helper.trans('labels.duration_seconds')
            }, null, 8, _hoisted_9), [
              [
                _vModelText,
                _ctx.durationSeconds,
                void 0,
                { number: true }
              ]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.validationError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.validationError), 1))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)), ["prevent"])),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        zoom: 0.5
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
            class: "btn btn-outline-danger btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.ban')), 1)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}